import React from 'react';
import { Clock, Check, AlertCircle, Loader2, X, FileText } from 'lucide-react';
import { getStatusColorClasses } from '../../../utils/socialMediaHelpers';

const STATUS_CONFIG = {
    draft: {
        label: 'Draft',
        icon: FileText,
    },
    scheduled: {
        label: 'Scheduled',
        icon: Clock,
    },
    publishing: {
        label: 'Publishing',
        icon: Loader2,
        animate: true,
    },
    published: {
        label: 'Published',
        icon: Check,
    },
    failed: {
        label: 'Failed',
        icon: AlertCircle,
    },
    cancelled: {
        label: 'Cancelled',
        icon: X,
    },
};

const StatusBadge = ({ status, showIcon = true, size = 'default' }) => {
    const config = STATUS_CONFIG[status?.toLowerCase()] || STATUS_CONFIG.draft;
    const colorClasses = getStatusColorClasses(status);
    const Icon = config.icon;

    const sizeClasses = size === 'small'
        ? 'text-xs px-2 py-0.5'
        : 'text-sm px-2.5 py-1';

    const iconSize = size === 'small' ? 'w-3 h-3' : 'w-3.5 h-3.5';

    return (
        <span className={`inline-flex items-center gap-1.5 rounded-full font-medium ${colorClasses} ${sizeClasses}`}>
            {showIcon && (
                <Icon className={`${iconSize} ${config.animate ? 'animate-spin' : ''}`} />
            )}
            {config.label}
        </span>
    );
};

export default StatusBadge;
